import styled from "styled-components";
import UnderConstructionImg from "../../assets/under-contruction.png";

export const PageWrapper = styled.main`
  width: 100%;
  min-height: 100vh;
  background-color: #fffaf4;
  color: #333;
`;

/* HERO (parallax-style background) */
export const HeroSection = styled.section`
  position: relative;
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  background-image: url(${UnderConstructionImg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed; /* image “stands still” on scroll */

  @media (max-width: 768px) {
    /* mobile fallback (fixed can be buggy on iOS) */
    background-attachment: scroll;
    min-height: 60vh;
  }
`;

export const HeroOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.55),
    rgba(0, 0, 0, 0.75)
  );
`;

export const HeroContent = styled.div`
  position: relative;
  padding: 1rem 1.5rem;
  max-width: 700px;
  color: #ffffff;
`;

export const HeroTitle = styled.h1`
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 800;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-bottom: 0.75rem;
  text-shadow: 0 4px 10px rgba(0, 0, 0, 0.6);
`;

export const HeroSubtitle = styled.p`
  font-size: clamp(1rem, 2vw, 1.25rem);
  line-height: 1.5;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.6);
`;

/* ABOUT SECTION */
export const AboutUsSection = styled.section`
  padding: 3rem 0rem 4rem;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 2rem 0rem 3rem;
  }
`;

export const AboutUsContent = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1.2fr);
  gap: 2.5rem;
  align-items: flex-start;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

/* Sticky image wrapper -> “standing still” effect while text scrolls */
export const AboutUsImageWrapper = styled.div`
  position: sticky;
  top: 90px;
  align-self: flex-start;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  max-height: 70vh;

  @media (max-width: 900px) {
    position: relative;
    top: 0;
    max-height: none;
  }
`;

export const AboutUsImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const AboutUsTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  line-height: 1.7;
`;

export const AboutUsTitle = styled.h2`
  font-size: clamp(1.8rem, 3vw, 2.3rem);
  margin-bottom: 0.5rem;
  letter-spacing: 1px;
`;

export const AboutUsText = styled.p`
  font-size: clamp(1rem, 1.5vw, 1.1rem);
  color: #444;
  text-align: justify;
  hyphens: auto;
  overflow-wrap: break-word;
`;
